var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @desc liquid chart
 */
import { createRef } from '@byted/light-render';
import { Group, Path, Rect } from '../../element';
import { SeriesModel } from '../../model';
import { registerChart } from '../index';
import { createRichText } from '../../rich';
import { getPercentOrNumberValue } from '../../utils/math';
import { createSymbol, getSymbolShapeFromCenter } from '../../symbol';
var LiquidModel = /** @class */ (function (_super) {
    __extends(LiquidModel, _super);
    function LiquidModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'liquid';
        _this._waterGroupRef = createRef();
        return _this;
    }
    LiquidModel.prototype.getDefaultOption = function () {
        return {
            type: 'liquid',
            name: '',
            visible: true,
            showLegend: false,
            encode: null,
            min: 0,
            max: 100,
            size: '100%',
            value: 0,
            symbol: 'circle',
            symbolStyle: {
                stroke: null,
                lineWidth: 4,
            },
            waterStyle: {
                fill: null,
                waveWidthLevel: 8,
                waveHeightLevel: 4,
            },
            label: {
                show: true,
                position: null,
                distance: 0,
                offsetX: 0,
                offsetY: 0,
                textAlign: 'center',
                textBaseline: 'middle',
                color: '#333333',
                fontSize: 28,
                formatter: function (data) { return data.value; },
            },
        };
    };
    LiquidModel.prototype.getInitialState = function () {
        return {
            cx: 0,
            cy: 0,
            radius: 0,
            needAnimation: this.needAnimation(),
            points: [],
        };
    };
    LiquidModel.prototype.init = function () {
        this._initAnimate = true;
    };
    LiquidModel.prototype.beforeRender = function () {
        var _a = this.getFacetBBox(), top = _a.top, left = _a.left, width = _a.width, height = _a.height;
        var size = this.option.size;
        var cx = left + width / 2;
        var cy = top + height / 2;
        var radius = getPercentOrNumberValue(size, Math.min(width, height)) / 2;
        var state = {
            cx: cx,
            cy: cy,
            radius: radius,
            needAnimation: this.state.needAnimation,
            points: [],
        };
        this.setState(state);
    };
    LiquidModel.prototype.afterRender = function () {
        this.animateBizeirWaveGroup();
        this._initAnimate = false;
    };
    LiquidModel.prototype.renderLiquidBackground = function () {
        var _a = this.getFacetBBox(), top = _a.top, left = _a.left, width = _a.width, height = _a.height;
        var fill = this.option.symbolStyle.fill;
        return new Rect({
            x: left,
            y: top,
            width: width,
            height: height,
            fill: fill,
        });
    };
    LiquidModel.prototype.renderLiquidOutline = function (ref) {
        var _a = this.state, cx = _a.cx, cy = _a.cy, radius = _a.radius;
        var _b = this.option, symbolStyle = _b.symbolStyle, symbol = _b.symbol;
        var stroke = symbolStyle.stroke || this.getSeriesColor();
        return createSymbol(__assign(__assign({ symbol: symbol }, symbolStyle), { stroke: stroke, fill: null }), getSymbolShapeFromCenter(cx, cy, radius * 2), __assign(__assign(__assign({ key: ref ? this.getKey('clip') : this.getKey('outline'), ref: ref }, symbolStyle), { stroke: stroke, fill: null }), (ref ? { fill: 'none', stroke: 'none' } : null)));
    };
    LiquidModel.prototype.renderBizeirWaveBrush = function (index, offsetX, offsetY) {
        if (index === void 0) { index = 0; }
        if (offsetX === void 0) { offsetX = 0; }
        if (offsetY === void 0) { offsetY = 0; }
        var radius = this.state.radius;
        var _a = this._getLiquidRects(), left = _a.left, bottom = _a.bottom, range = _a.range;
        var _b = this.option, value = _b.value, _c = _b.waterStyle, waveWidthLevel = _c.waveWidthLevel, waveHeightLevel = _c.waveHeightLevel;
        var waterLevel = value / range;
        var loop = waveWidthLevel * 2;
        var waveHeightControlPointY = radius / (8 / waveHeightLevel);
        var partNumber = (loop * 8) / waveWidthLevel;
        var step = (radius * waveWidthLevel) / 16;
        var startOffsetX = ((index * radius) / 8) * 1.234;
        var x = left + startOffsetX - radius * (loop - 1) * 2 + offsetX;
        var y = bottom - radius * 2 * waterLevel - offsetY;
        return function (ctx) {
            ctx.moveTo(x, bottom);
            ctx.lineTo(x, y);
            for (var i = 0; i < partNumber; i++) {
                ctx.bezierCurveTo(x + (i * 4 + 2) * step, y - waveHeightControlPointY, x + (i * 4 + 2) * step, y + waveHeightControlPointY, x + (i * 4 + 4) * step, y);
            }
            ctx.lineTo(x + radius * loop * 2, bottom);
        };
    };
    LiquidModel.prototype.renderBizeirWave = function (index, offsetX, offsetY) {
        if (index === void 0) { index = 0; }
        if (offsetX === void 0) { offsetX = 0; }
        if (offsetY === void 0) { offsetY = 0; }
        var fill = this.option.waterStyle.fill;
        return new Path({
            brush: this.renderBizeirWaveBrush(index, offsetX, offsetY),
            fill: fill || this.getSeriesColor(),
            opacity: Math.pow(0.8, index) * 0.6,
        });
    };
    LiquidModel.prototype.renderBizeirWaveGroup = function () {
        var group = new Group({
            key: this.getKey('waterWave'),
            ref: this._waterGroupRef,
        });
        group.add(this.renderBizeirWave());
        group.add(this.renderBizeirWave(1));
        group.add(this.renderBizeirWave(2));
        return group;
    };
    LiquidModel.prototype.renderText = function () {
        var _a = this.option, value = _a.value, label = _a.label;
        var _b = this.state, cx = _b.cx, cy = _b.cy, radius = _b.radius;
        var offsetX = label.offsetX, offsetY = label.offsetY, formatter = label.formatter, otherLabelOption = __rest(label, ["offsetX", "offsetY", "formatter"]);
        var x = cx + getPercentOrNumberValue(offsetX, radius);
        var y = cy + getPercentOrNumberValue(offsetY, radius);
        return createRichText(__assign({ x: x,
            y: y, text: this.formatItem(formatter, { value: value }), fill: label.color }, this.getTextStyle(otherLabelOption)));
    };
    LiquidModel.prototype.animateBizeirWaveGroup = function () {
        var _this = this;
        var radius = this.state.radius;
        var range = this._getLiquidRects().range;
        var waveWidthLevel = this.option.waterStyle.waveWidthLevel;
        var step = (radius * waveWidthLevel) / 16;
        var value = this.option.value;
        var waterLevel = value / range;
        var initAnimate = this._initAnimate;
        this._waterGroupRef.current.children().forEach(function (item, index) {
            item.animateTo({}, {
                during: ((initAnimate ? 3000 : 3000 - index * 700) / 4) * (initAnimate ? 2 : waveWidthLevel),
                ease: 'Linear',
                onFrame: function (progress) {
                    item.setAttr({
                        brush: _this.renderBizeirWaveBrush(index, progress * step * 4, initAnimate ? -(1 - progress) * radius * 2 * waterLevel : 0),
                    });
                },
                callback: function () {
                    _this.animateBizeirWaveGroup();
                },
            });
        });
    };
    LiquidModel.prototype.render = function () {
        var clipRef = createRef();
        var liquidOutline = this.renderLiquidOutline();
        var clip = this.renderLiquidOutline(clipRef);
        var group = new Group({
            key: this.getKey('liquid'),
            clip: clipRef,
        });
        group.add(this.renderLiquidBackground());
        group.add(this.renderBizeirWaveGroup());
        group.add(this.renderText());
        group.add(liquidOutline);
        group.add(clip);
        return group;
    };
    LiquidModel.prototype._getLiquidRects = function () {
        var _a = this.state, cx = _a.cx, cy = _a.cy, radius = _a.radius;
        var _b = this.option, max = _b.max, min = _b.min;
        return {
            range: max - min,
            bottom: cy + radius,
            top: cy - radius,
            right: cx + radius,
            left: cx - radius,
        };
    };
    return LiquidModel;
}(SeriesModel));
export default LiquidModel;
registerChart('liquid', LiquidModel);
